<template>
  <div class="border p-1 rounded product-card-310-category">
    <m-product-offer1 :offer-status="offerStatus" :offer-type="offerType" class="position-absolute" :product="product"/>
    <m-card310_-category :alt="product.name" :image="product.thumbnail"
                         :image-link="{ name: 'Product', params: { name: product.raw_link } }">

      <m-a :href="{ name: 'Product', params: { name: product.raw_link } }">
        <h5 class="product-card-310-category-text">{{ contentSlicer(product.name, 50) }}</h5>
      </m-a>

      <div class="" v-if="showKeywords">
        <span class="badge product-card-310-categorykeyword m-1" v-for="item in product.keywords">{{
            item.keyword
          }}</span>
      </div>

      <div class="card-310-category-categories" v-for="category in product.category"
           :class="`card-310-category-categories-item-${category.id}`">
        <span class="btn btn-sm product-card-3-1-categories-badge m-1 btn-primary rounded-pill">
          {{ category.name }}
        </span>
      </div>


      <m-product-card-quantity-manager1 class="text-center product-card-310-category-quantity-manager"
                                        :product="product"/>

    </m-card310_-category>
  </div>

</template>

<script>
import mCard310_Category from "../../Cards/Card310_Category.vue";
import mProductCardQuantityManager1 from "../../Product/QuantityManager/Card/ProductCardQuantityManager1";
import mProductPrice100 from "../../Product/ProductPrice100";
import mA from '../../Tags/A'
import mProductOffer1 from "../../Product/ProductOffer/ProductOffer1";
import {OfferProps} from '../ProductOffer/ProductOfferProps'
import {shoppingCartFunctions} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";

export default {
  name: "ProductCard310",
  components: {mCard310_Category, mProductCardQuantityManager1, mA, mProductPrice100, mProductOffer1},
  props: {
    product: {},
    productCardLink: {
      default: '_self',
    },
    showKeywords: {
      type: Boolean,
      default: false
    },
    OfferProps
  },
  methods: {
    ...shoppingCartFunctions,
  }
}
</script>

<style scoped>
.product-card-310-category :deep(.card-317-image) {
  object-fit: cover;
  border-radius: 100%;
  border: 2px solid var(--primary);
  height: 100px;
  width: 100px;
}

.card-310-category-categories * {
  font-size: 10px !important;
}
</style>